import { Html } from '@react-three/drei';
import PropTypes from 'prop-types';
import React from 'react';

function BodyPoint({ index, onClick, position }) {
	return (
		<Html center position={position}>
			<div
				className="body-point"
				onClick={onClick}
				style={{ '--delay': `${index * 50}ms` }}
			>
				<div className="body-point-inner" />
			</div>
		</Html>
	);
}

BodyPoint.propTypes = {
	index: PropTypes.number,
	onClick: PropTypes.func,
	position: PropTypes.array,
};

export default BodyPoint;
